export default __webpack_public_path__ + "lee@2x.68b11d91.png";